import ConfirmedRentalContainer from './ConfirmedRentalContainer';

export default ConfirmedRentalContainer;
